let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eVnxm")).then(() => parcelRequire('5MSS3'));